import { Grid } from '@mui/material';
import { TournamentTeamEntity } from 'app/interfaces/entity';
import { TournamentTeamCard } from 'modules/tournaments/components/BracketTournament/TournamentTeams/TournamentTeamCard';
import { disqualifyTeam } from 'modules/tournaments/store/current-tournament/repository';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ConfirmationDialog } from 'shared/components/ConfirmationDialog';
import { useStyles } from './TournamentTeamsList.styles';

interface TournamentTeamsListProps {
  teams: TournamentTeamEntity[];
  teamsSize: number;
}

export const TournamentTeamsList: FC<TournamentTeamsListProps> = ({ teams, teamsSize }) => {
  const dispatch = useDispatch();
  const { classes } = useStyles();

  const tournament = useSelector(currentTournamentSelector.tournament);

  const onDisqualifyHandler = useCallback(
    (selectedTeam: TournamentTeamEntity) => {
      dispatch(disqualifyTeam({ tournamentId: tournament.id, teamId: selectedTeam.id }));
    },
    [dispatch, tournament.id]
  );

  if (!teams || !teams?.length) {
    return null;
  }

  return (
    <>
      <Grid container className={classes.container} spacing={2}>
        {teams.map((team) => (
          <Grid item key={team.name}>
            <TournamentTeamCard team={team} teamsSize={teamsSize} />
          </Grid>
        ))}
      </Grid>
      <ConfirmationDialog
        title={`Disqualify Team`}
        description="Are you sure you want to disqualify the team?"
        onAccept={onDisqualifyHandler}
      />
    </>
  );
};
